import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { ActiveToast } from 'components/layout'
import { AwardCompletedModal } from 'components/modals'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'

@modal.trigger()
class StartNewAward extends Component {
  static propTypes = {
    isCompleted: PropTypes.bool,
    showNewLevelMessage: PropTypes.bool,
    onOpen: PropTypes.func,
    awardId: PropTypes.number,
    awardLevelText: PropTypes.string,
  }

  openAwardApproval = () => this.props.onOpen(MODALS.START_NEW_AWARD, null, null)

  render() {
    const {
      awardLevelText,
      isCompleted,
      showNewLevelMessage,
      awardId
    } = this.props

    return (
      <div>
        <ActiveToast
          text='You have now completed your Award. Would you like to start a new one?'
          intlKey='label.you_have_now_completed_your_award'
          intlValues={{ level: awardLevelText || '' }}
          action='Send'
          actionKey='button.yes'
          onClick={this.openAwardApproval}
          toShow={isCompleted && showNewLevelMessage}
        />
        <AwardCompletedModal
          intlValues={{ level: awardLevelText || '' }}
          modalId={MODALS.START_NEW_AWARD}
          awardId={awardId}
        />
      </div>
    )
  }
}

export default StartNewAward
